import { AxiosError } from "axios";

import api from "../api";

interface CheckDocumentRequest {
  token: string | null;
  document: string;
}

export const HearingInviteRoomService = {
  getHearingInfo: async (token: string) => {
    try {
      const { data } = await api.get(
        `/v1/HearingInviteRoom/GetHearingInfo?token=${token}`,
      );
      return {
        success: true,
        data: data.data || data,
      };
    } catch (error: any) {
      return {
        success: false,
        message:
          error.response?.data || "Erro ao buscar informações da audiência",
        statusCode: error.response?.status,
      };
    }
  },

  checkDocument: async (data: CheckDocumentRequest) => {
    try {
      const { data: responseData } = await api.post(
        `/v1/HearingInviteRoom/CheckDocument?token=${data.token}&document=${data.document}`,
      );
      return {
        success: true,
        data: responseData.data || responseData,
      };
    } catch (error: any) {
      return {
        success: false,
        message:
          error.response?.data ||
          "Documento informado inválido. Verifique os dados e tente novamente.",
        statusCode: error.response?.status,
      };
    }
  },
};
